import { InjectionToken, StaticProvider } from '@angular/core';

import { BaseApiConfig, EndpointParserFn } from '../../models/base-api-config.model';

/**
 * Provides API configuration for invoice related endpoints across the application.
 *
 * The `InvoiceApiConfig` is injected via `INVOICE_API_CONFIG`
 */

export type InvoiceApiConfig = BaseApiConfig<{
  getInvoice: EndpointParserFn;
  getInvoices: string;
  createInvoice: string;
}>;

export const INVOICE_API_CONFIG = new InjectionToken<InvoiceApiConfig>('INVOICE_API_CONFIG');

export const provideInvoiceApiConfig = (config: InvoiceApiConfig): StaticProvider => ({
  provide: INVOICE_API_CONFIG,
  useValue: config,
});
